// extracted by mini-css-extract-plugin
export default {"confirm":"n0_dOz","priceCurrency":"Qlbis4","priceLabel":"ZBludY","price":"iFCLuj mz-default-dark-font","button":"ZgcQVe","greenCTA":"kuYtIJ mz-cta-green"};